import {Service} from '@s-ui/domain'

export default class GetAuthenticationTrackingService extends Service {
  constructor({gigyaEventToPageNameMapper, trackingDataService}) {
    super({
      gigyaEventToPageNameMapper,
      trackingDataService
    })

    this._gigyaEventToPageNameMapper = gigyaEventToPageNameMapper
    this._trackingDataService = trackingDataService
  }

  execute = async ({gigyaEvent}) => {
    const domainPageName = this._gigyaEventToPageNameMapper.map({gigyaEvent})

    let segmentEventProps

    if (domainPageName) {
      segmentEventProps = await this._trackingDataService.execute({
        page: domainPageName,
        errorCode: gigyaEvent.getErrorCode()
      })
    }

    return {segmentEventProps}
  }
}
